export function matchHexColor(color: string) {
  return color === '' || /^#[0-9a-fA-F]{3}([0-9a-fA-F]{3})?$/.test(color);
}
